// extracted by mini-css-extract-plugin
export default {"containerSection":"HeaderSection_containerSection__kLTlv","h2":"HeaderSection_h2__uhUF5","h2_3xl":"HeaderSection_h2_3xl__KVRBa","text-center":"HeaderSection_text-center__0-44o"};